(function ($) {
  $(document).ready(function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    // A global dictionary of default animation targets and their initial states/durations
    let gsapEffects = {
      'fade-in': { autoAlpha: 0, duration: 1, ease: 'power2.out' },
      'slide-up': { autoAlpha: 0, y: 40, duration: 0.6, ease: 'power3.out' },
      'mask-up': { y: '110%', duration: 0.8, ease: 'expo.out' }, // Safely shifts out of bounds
      'widen': { width: 0, duration: 0.25, ease: 'power4.inOut' }
    };

    let defaultRevealRules = {
      'mask-up': 'h1, h2, h3, h4, h5, h6, p, li, .button',
      'slide-up': '.image-container, picture, video',
      'widen': '.line-separator'
    };

    // Allow child themes to override or extend the animation configuration
    if (window.revealAnimationConfig) {
      if (window.revealAnimationConfig.effects) {
        gsapEffects = Object.assign({}, gsapEffects, window.revealAnimationConfig.effects);
      }
      if (window.revealAnimationConfig.rules) {
        defaultRevealRules = Object.assign({}, defaultRevealRules, window.revealAnimationConfig.rules);
      }
    }

    // Automatically target every single custom block section wrapper, except the Hero section
    $('section[class*="block-"]:not(.hero), [data-reveal-container]').each(function () {
      const $container = $(this);

      // Auto-tag un-tagged children based on our CSS dictionary rules
      Object.keys(defaultRevealRules).forEach(effect => {
        const selector = defaultRevealRules[effect];
        if (!selector) return; // Allow removing a rule by overriding it with false/empty

        // Find elements inside this container that match the rule, but skip if manually defined or explicitly excluded
        $container.find(selector).not('[data-reveal-item], .no-reveal, .no-reveal *').each(function () {

          // Wrap 'mask-up' items automatically in an overflow:hidden mask!
          if (effect === 'mask-up') {
            if (typeof SplitType !== 'undefined' && $(this).is('h1, h2, h3, h4, h5, h6, p, li, a, span, .button, blockquote, dt, dd')) {
              // Split text into lines natively without destroying element margins
              const split = new SplitType(this, { types: 'lines' });

              $(split.lines).each(function () {
                // position: relative ensures transform boundaries are respected for clipping
                $(this).css({ overflow: 'hidden', verticalAlign: 'top', position: 'relative' });
                $(this).wrapInner('<div class="reveal-mask-inner" style="display: block; position: relative;"></div>');
              });
              $(this).addClass('is-split-type');
            } else if ($(this).parent('.reveal-mask').length === 0) {
              $(this).wrap('<div class="reveal-mask" style="overflow: hidden; display: block; opacity: 1;"></div>');
            }
          }

          $(this).attr('data-reveal-item', effect);
        });
      });

      const $items = $container.find('[data-reveal-item]');
      if ($items.length === 0) return;

      // Custom configuration flags via HTML dataset or ACF Block settings
      const startOffset = $container.data('reveal-start') || 'top 80%';

      // 1. Prepare animation states and immediately hide items
      $items.each(function () {
        const effectName = $(this).data('reveal-item');
        const effectSettings = gsapEffects[effectName];

        if (effectName == 'mask-up') {
          $(this).wrap('<div class="reveal-mask" style="overflow: hidden; display: block; opacity: 1;"></div>');
        }

        if (effectSettings) {
          const target = $(this).hasClass('is-split-type') ? $(this).find('.reveal-mask-inner') : this;
          const internalStagger = $(this).hasClass('is-split-type') ? 0.1 : 0; // Stagger text lines

          let fromState = Object.assign({}, effectSettings);
          delete fromState.duration;
          delete fromState.ease;

          let toState = {
            x: 0, y: 0, yPercent: 0, scale: 1, rotation: 0, autoAlpha: 1, clearProps: "transform,opacity,visibility",
            duration: $(this).hasClass('is-split-type') ? 0.8 : effectSettings.duration,
            ease: effectSettings.ease,
            stagger: internalStagger
          };

          if (effectSettings.width !== undefined) {
            toState.width = '100%';
          }

          // Force the starting position immediately so it stays hidden before the trigger
          gsap.set(target, fromState);

          // Save references onto the DOM node for the batch processor
          $(this).data('gsap-target', target);
          $(this).data('gsap-from', fromState);
          $(this).data('gsap-to', toState);
        }
      });

      // 2. Feed all items into a ScrollTrigger Batch
      ScrollTrigger.batch($items.toArray(), {
        start: startOffset,
        once: true, // Fire the animation strictly once
        onEnter: (batch) => {
          // 'batch' contains all DOM elements that triggered crossing startOffset in the same scroll-tick
          batch.forEach((el, index) => {
            const target = $(el).data('gsap-target');
            const toState = $(el).data('gsap-to');
            const fromState = $(el).data('gsap-from');

            if (target && toState && fromState) {
              // Add a dynamic stagger offset based on its index in this simultaneous batch!
              const finalToState = Object.assign({}, toState, { delay: index * 0.1 });
              
              gsap.fromTo(target, fromState, finalToState);
            }
          });
        }
      });
    });

  });
})(jQuery);
